import { render } from "./UserAvatar.vue?vue&type=template&id=0e03beea"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=0e03beea&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/UserAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e03beea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e03beea', __exports__)) {
    console.log('reload')
    api.reload('0e03beea', __exports__)
  }
  
  module.hot.accept("./UserAvatar.vue?vue&type=template&id=0e03beea", () => {
    console.log('re-render')
    api.rerender('0e03beea', render)
  })

}


export default __exports__